function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var defaultIdFactory = function defaultIdFactory() {
  return "fa-".concat(Date.now().toString(36), "-").concat(Math.random().toString(36).slice(2, 10));
};
export default {
  name: 'FreeActivityQuantityDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    currentState: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    submitting: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '免费活动预约'
    },
    quantityLabel: {
      type: String,
      default: '本次人数'
    },
    errorMessage: {
      type: String,
      default: ''
    },
    idFactory: {
      type: Function,
      default: defaultIdFactory
    }
  },
  data: function data() {
    return {
      quantity: 1,
      operation: null
    };
  },
  computed: {
    remainingNum: function remainingNum() {
      return Math.max(Number(this.currentState.remainingNum || 0), 0);
    },
    dialogVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(value) {
        if (!value) this.$emit('close');
      }
    }
  },
  watch: {
    visible: function visible(value) {
      if (value) this.reset();
    },
    currentState: function currentState() {
      this.quantity = 1;
      this.operation = null;
    }
  },
  methods: {
    reset: function reset() {
      this.quantity = 1;
      this.operation = null;
    },
    onQuantityChange: function onQuantityChange(value) {
      var quantity = Math.min(Math.max(Number(value || 1), 1), this.remainingNum || 1);
      if (this.operation && this.operation.quantity !== quantity) this.operation = null;
      this.quantity = quantity;
    },
    confirm: function confirm() {
      if (this.submitting || !this.remainingNum) return;
      if (!this.operation || this.operation.quantity !== this.quantity) {
        this.operation = {
          quantity: this.quantity,
          operationId: this.idFactory()
        };
      }
      this.$emit('confirm', _objectSpread({}, this.operation));
    },
    close: function close() {
      if (!this.submitting) this.$emit('close');
    }
  }
};